import { useContext } from "react"
import { AppContext } from "../context/AppContext"


function Layout(props) {

    const { sidebar } = useContext(AppContext)

    return (
        <div
            className={sidebar ? "taskMain " : "cx-active taskMain"}
            id="cx-main"
        >
            <div className="role-content">
                {props.children}
            </div>
        </div>
    )

}

export default Layout